import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export const BUSCAR_CONFIGURACOES_BILHETE = '@configuraBilheteAction/BUSCAR_CONFIGURACOES_BILHETE';
export const CADASTRAR_CONFIGURACAO_BILHETE = '@configuraBilheteAction/CADASTRAR_CONFIGURACAO_BILHETE';
export const ALTERAR_CONFIGURACAO_BILHETE = '@configuraBilheteAction/ALTERAR_CONFIGURACAO_BILHETE';

export function buscarConfiguracoesBilhete (codigoEmpresa) {
    const url = `${URL}/config-bilhete/empresa/${codigoEmpresa}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_CONFIGURACOES_BILHETE,
        payload: response
        
      })
    );
  }

export function cadastrarConfiguracaoBilhete (configuracao, idEmpresa) {
  const url = `${URL}/config-bilhete/empresa/${idEmpresa}/cadastrar`;
  return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_CONFIGURACAO_BILHETE,
      payload: response
    })
  );
}

export function alterarConfiguracaoBilhete(configuracao, idEmpresa) {
  const url = `${URL}/config-bilhete/empresa/${idEmpresa}/alterar`;
  return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ALTERAR_CONFIGURACAO_BILHETE,
      payload: response
    })
  );
}
